import { Injectable } from '@angular/core';
import { Cart, CartModificationList } from '@spartacus/cart/base/root';
import { Observable } from 'rxjs';
import { GenAutoShipEntriesRequest } from '../../../../models/auto-ship.model';
import { GenAutoShipCartAdapter } from './auto-ship-cart.adapter';

@Injectable()
export class GenAutoShipCartConnector {
  constructor(private adapter: GenAutoShipCartAdapter) { }

  load(userId: string, cartId: string): Observable<Cart> {
    return this.adapter.load(userId, cartId);
  }

  updateEntries(
    userId: string,
    cartId: string,
    request: GenAutoShipEntriesRequest,
  ): Observable<CartModificationList> {
    return this.adapter.updateEntries(userId, cartId, request);
  }
}
